import React from 'react'
import { getIconShare } from 'utils'
import LinkAnimate from 'utils/hooks/linkAnimate'
import { ShareHackernews, ShareLinkedin, ShareReddit, ShareTwitter, ShareCopyLink } from 'utils/share'
import { COMMON } from 'utils/intl/common.js'

function AuthorArticle(props) {
  const { slug, data, title, className = '', isDark = false } = props

  const isBrowser = typeof window !== `undefined`
  let shareUrl = ''
  if (isBrowser) shareUrl = window.location.href.replace('blog//', 'blog/').replace('tech-story//', 'tech-story/')

  return (
    <>
      <div className={`article__author ${className} mt-5`}>
        <div className="f--tablet">
          {!data.website && (
            <LinkAnimate to={slug} className="f mb-1 mb-lg-0">
              <img
                loading="lazy"
                className="img-circle img-circle--big"
                src={data.picture ? data.picture.url : data.logo.url}
                alt={data.name.text}
              />
            </LinkAnimate>
          )}
          {data.website && (
            <a href={data.website.url} className="f mb-1 mb-lg-0" target="_blank" rel="noopener noreferrer">
              <img
                loading="lazy"
                className="img-circle img-circle--big"
                src={data.picture ? data.picture.url : data.logo.url}
                alt={data.name.text}
              />
            </a>
          )}
          <div>
            <span className={`f ft-up ft-tertiary ft-600 mb-1 ${isDark ? 'c-white' : 'c-text-black-lightest'}`}>
              {title}
            </span>
            <h4 className={`ft-600 mb-1 ${isDark ? 'c-white' : 'c-text-black-lighter'}`}>{data.name.text}</h4>
            <p className={`ft-secondary mb-2 ${isDark ? 'c-text-white-darker' : 'c-text-black-light'}`}>
              {data.description.text}
            </p>
            {!data.logo && (
              <LinkAnimate className={`btn btn--secondary ${isDark ? 'btn--transparent' : ''}`} to={slug}>
                {COMMON.SEE_ALL_ARTICLES}
              </LinkAnimate>
            )}
          </div>
        </div>
        <div className={`article__author__shares ${!data.logo ? 'mt-5' : 'mt-3'} mt-lg-0`}>
          <ShareHackernews className={`link-social ${isDark ? 'link-social--dark-bis' : ''}`} url={shareUrl}>
            {getIconShare('hackernews')}
          </ShareHackernews>
          <ShareLinkedin className={`link-social ${isDark ? 'link-social--dark-bis' : ''}`} url={shareUrl}>
            {getIconShare('linkedin')}
          </ShareLinkedin>
          <ShareTwitter className={`link-social ${isDark ? 'link-social--dark-bis' : ''}`} url={shareUrl}>
            {getIconShare('twitter')}
          </ShareTwitter>
          <ShareReddit className={`link-social ${isDark ? 'link-social--dark-bis' : ''}`} url={shareUrl}>
            {getIconShare('reddit')}
          </ShareReddit>
          <ShareCopyLink className={`link-social ${isDark ? 'link-social--dark-bis' : ''}`} url={shareUrl}>
            {getIconShare()}
          </ShareCopyLink>
        </div>
      </div>
      {data.headquarters && (
        <div className="article__company mt-5">
          <div className="article__company__section">
            {data.headquarters.text && (
              <div>
                <span className="f ft-up ft-tertiary c-text-black-lightest ft-600 mb-1">{COMMON.HEADQUARTERS}</span>
                <p className="ft-tertiary c-text-black-light mb-0">{data.headquarters.text}</p>
              </div>
            )}
            {data.founded.text && (
              <div>
                <span className="f ft-up ft-tertiary c-text-black-lightest ft-600 mb-1">{COMMON.FOUNDED}</span>
                <p className="ft-tertiary c-text-black-light mb-0">{data.founded.text}</p>
              </div>
            )}
            {data.company_size.text && (
              <div>
                <span className="f ft-up ft-tertiary c-text-black-lightest ft-600 mb-1">{COMMON.COMPANY_SIZE}</span>
                <p className="ft-tertiary c-text-black-light mb-0">{data.company_size.text}</p>
              </div>
            )}
          </div>
          <div className="article__company__section">
            {data.key_challenges.text && (
              <div>
                <span className="f ft-up ft-tertiary c-text-black-lightest ft-600 mb-1">{COMMON.KEY_CHALLENGES}</span>
                <p className="ft-tertiary c-text-black-light mb-0">{data.key_challenges.text}</p>
              </div>
            )}
            {data.solutions.text && (
              <div>
                <span className="f ft-up ft-tertiary c-text-black-lightest ft-600 mb-1">{COMMON.SOLUTIONS}</span>
                <p className="ft-tertiary c-text-black-light mb-0">{data.solutions.text}</p>
              </div>
            )}
            {data.key_results.text && (
              <div>
                <span className="f ft-up ft-tertiary c-text-black-lightest ft-600 mb-1">{COMMON.KEY_RESULTS}</span>
                <p className="ft-tertiary c-text-black-light mb-0">{data.key_results.text}</p>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  )
}

export default AuthorArticle
